//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "declarationinfo",
    data () {
      return {
        lastdeclarationinfo:"",
        status:false,
        currently:[{ //当前是否已注册测试数据
          propertyValue:"1",
          propertyLabel:"YES"
        },
        { //当前是否已注册测试数据
          propertyValue:"0",
          propertyLabel:"NO"
        },
        ],
      };
    },
   props: {
      //业务数据
      record: { type: Object, default: () => ({}) },
      //流程数据
      process: { type: Object, default: () => ({}) },
      //规则绑定
      rules: { type: Object, default: () => ({}) },
      //自定义的参数
      config: { type: Object, default: () => ({}) },
    },
    methods:{
      checkChange(rowid,e){//多选改单选
       this.record.declarationinfo[rowid].checktypes=[];
       this.record.declarationinfo[rowid].checktypes.push(e);
      }
    }
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/resumeApply/declarationinfo.vue